export default {
  setConfirmProduct(state, product) {
    const payPrice = state.payPrice
    state.confirmProduct = product
    state.confirmProduct.payPrice = payPrice
  },
  setSelectedCoupon(state, coupon) {
    state.selectedCoupon = coupon
  },
  setCouponList(state, list) {
    state.couponList = list
  },
  setConfirmCoupons(state, data) {
    // console.log('setConfirmCoupons', data)
    state.confirmCoupons.usableList = data.usableList || []
    state.confirmCoupons.disableList = data.disableList || []
  },
  resetConfirmCoupons(state) {
    state.confirmCoupons = { usableList: [], disableList: [] }
  },
  setConfirmSelected(state, payload) {
    state.confirmSelected = { ...state.confirmSelected, ...payload }
  },
  setIsOpenAppCashier(state, payload) {
    state.isOpenAppCashier = payload
  },
  setOrderPayPrice(state, price) {
    state.payPrice = price
  },
  setIsSupportScore(state, isSupportScore) {
    state.isSupportScore = isSupportScore
  },
  setOrderPayScore(state, score) {
    state.payScore = score
  },
  setIsLessScore(state, isLessScore) {
    state.isLessScore = isLessScore
  }
}
